import { FunctionComponent } from "react";
import { FieldProps } from "@animech/axiom-ui-builder";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Root } from "@definitions";
import { useUiData } from "src/ui/data";

export type ConditionalMessageProps = {
	triggerValues: unknown[];
	termKey: string;
};

type Props = FieldProps<Root> & ConditionalMessageProps;

const MessageWrapper = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: ${theme.dimensions.margin.xxSmall};
		margin-bottom: ${theme.dimensions.margin.small};
		font-family: ${theme.typography.fontFamily.primary};
		font-size: ${theme.typography.fontSize.base};
		font-weight: 300;
		color: ${theme.colors.foregrounds[1]};
	`}
`;

export const ConditionalMessage: FunctionComponent<Props> = ({
	value,
	triggerValues,
	termKey,
}) => {
	const { localizer } = useUiData();

	if (!triggerValues.includes(value)) {
		return null;
	}

	return (
		<MessageWrapper>
			<span>&#9432;</span>
			<span>{localizer.localizeTerm(termKey)}</span>
		</MessageWrapper>
	);
};
